// extracted by mini-css-extract-plugin
module.exports = {"modalError":"modalError--85de8","modalErrorBox":"modalErrorBox--319df","modalErrorTitle":"modalErrorTitle--4eb98"};